import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-brand-main font-sans text-brand-text selection:bg-brand-orange/25" data-id="element-0" data-mp="23w4fq47h1a2f">
      <CountdownBar data-id="element-1" data-mp="3iiweonbohg2p" />
      <main data-id="element-2" data-mp="3ijfu9xduvsdk">
        <HeroSection data-id="element-3" data-mp="3ihv22ef0kliv" />
        <StatsBar data-id="element-4" data-mp="3mlj82snzz920" />
        <TransformationSection data-id="element-5" data-mp="3ml12h5fg3ihf" />
        <PainPointsSection data-id="element-6" data-mp="3mjzsz5e2v41t" />
        <KitContentsSection data-id="element-7" data-mp="3mj6ibtbzzuee" />
        <InstantAccessSection data-id="element-8" data-mp="3rbr9so7flver" />
        <BonusesSection data-id="element-9" data-mp="3rdkgg3i1ofmr" />
        <PricingSection data-id="element-10" data-mp="3recf5n6xuth9" />
        <GuaranteeSection data-id="element-11" data-mp="5yh2n2cyzbp" />
        <TestimonialsSection data-id="element-12" data-mp="680frswe88f" />
        <FAQSection data-id="element-13" data-mp="5gbgztt38r4" />
        <FinalCTASection data-id="element-14" data-mp="7suzhf7pr6a" />
      </main>
      <Footer data-id="element-15" data-mp="2zlv7cvunj3vl" />
    </div>;
}